// extracted by mini-css-extract-plugin
export default {"ChangePasswordForm":"style_ChangePasswordForm__cb8S3","FieldErrors":"style_FieldErrors__KSKjy"};